import React from 'react';
import { AlertOctagon, AlertTriangle, CheckCircle2, HelpCircle, Hourglass } from 'lucide-react';
import { usePollerHealth } from '../hooks/usePollerHealth';

const ICONS = {
  down: AlertOctagon,
  stale: Hourglass,
  degraded: AlertTriangle,
  ok: CheckCircle2,
  unknown: HelpCircle,
};

// The alarm for the scheduled poller. Red means a person must act; it never
// depends on anyone reading GitHub.

export function runLinkLabel(url) {
  const value = String(url || '');
  if (value.includes('console.cloud.google.com')) return 'Open the run in Google Cloud';
  if (value.includes('github.com')) return 'Open the run on GitHub';
  return 'Open the run';
}

export default function PollerHealthPanel() {
  const { health, loaded, error } = usePollerHealth();
  if (!loaded && !error) return null;
  const view = error
    ? { tone: 'unknown', headline: 'Scheduled poller: heartbeat unreadable', detail: error.message || String(error) }
    : health;
  const Icon = ICONS[view.tone] || HelpCircle;
  const link = view.tone === 'down' || view.tone === 'degraded' ? view.lastFailureUrl : view.lastRunUrl;
  return (
    <section
      className={`admin-ops-poller is-${view.tone}`}
      aria-label="Scheduled poller health"
      data-testid="poller-health"
      data-tone={view.tone}
    >
      <Icon size={22} aria-hidden="true" />
      <div>
        <strong>{view.headline}</strong>
        <span>{view.detail}</span>
        {link && (
          <small>
            {/* The label follows the URL rather than asserting a host. The
                heartbeat moved off GitHub Actions onto Cloud Scheduler and Cloud
                Run on 2026-08-27, and this link went with it — but the words
                did not, so the panel spent the migration telling its operator to
                open a run on a service that no longer runs it. Historical
                failure links still point at GitHub, so both are live at once and
                a hardcoded label is wrong for one of them whichever it names. */}
            <a href={link} target="_blank" rel="noreferrer">{runLinkLabel(link)}</a>
          </small>
        )}
      </div>
    </section>
  );
}
